import palette from './palette';
import components from './components';
import breakpoints from './breakpoints';

export default {
  palette,
  components,
  breakpoints,
};
